import clsx from "clsx";
import React from "react";
import { MdCheck, MdPriorityHigh } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { ICON_SIZES } from "src/constants/icons";
import { IFieldLabel } from "./FieldLabel.types";

const FieldLabel: React.FC<IFieldLabel> = ({
  htmlFor,
  required = false,
  text,
  valid = false,
  onClick = () => undefined,
  className = "",
}) => {
  const { t } = useTranslation();

  return (
    <label
      htmlFor={htmlFor}
      className={clsx([
        "text-xs",
        "md:text-sm",
        "dark:text-gray-100",
        "font-medium",
        "inline-flex",
        "items-center",
        className,
      ])}
      onClick={onClick}
    >
      <div
        title={
          required ? t("info_blocks:fields_validation.required_field") : ""
        }
        className="truncates"
      >
        {text}
      </div>
      {required && (
        <>
          <span
            className={clsx([
              "ml-1",
              "cursor-help",
              {
                "text-lime-400": valid,
                "text-gray-400/80 dark:text-gray-400/80": !valid,
              },
            ])}
            title={
              required ? t("info_blocks:fields_validation.required_field") : ""
            }
          >
            {valid ? (
              <MdCheck size={ICON_SIZES.XS} />
            ) : (
              <MdPriorityHigh size={ICON_SIZES.XS} />
            )}
          </span>
        </>
      )}
    </label>
  );
};

export default React.memo(FieldLabel);
